import { ThemeProvider as NextThemesProvider } from "next-themes";
import type { ReactNode } from "react";

/**
 * Mounts `next-themes` with the conventions used across pahfacturar:
 *   - `class` strategy (Tailwind `darkMode: ["class"]`)
 *   - `system` enabled and used as default
 *   - disabled SSR transition flicker since we always render client-side
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  );
}
